export default __webpack_public_path__ + "assets/exercise_big.png";